import { type Block, type Content, type Locale, type StoryPage } from "@/react/story/types";
import { createContext, useContext } from "react";

type Context = {
    inLocale: (locale: Locale) => string[];
    inPage: (page: StoryPage, locale?: Locale | null) => string[];
    inBlock: (block: Block, locale?: Locale | null) => string[];
    inContent: (content: Content, locale?: Locale | null) => string[];
}

export const ErrorsContext = createContext<Context>({} as Context);

export const useErrors = () => useContext(ErrorsContext);
